<template>
    <div style="padding: 15px; padding-bottom:0; color:#000; margin-bottom: 50px;">
        <div class="row">

            <!-- Checkbox and Comment -->
            <div class="col-md-12 quiz-message-row">
                <div class="row">
                    <div class="col-md-6 text-left">
                        Question #{{idx + 1}}
                        <span class="pull-right">
                            <input type="checkbox"
                                   :id="qid+'_correction'"
                                   name="questionsToCorrect[]"
                                   :value="qid"
                                   @change="handleChange"
                            />
                        <label :for="qid+'_correction'">Mark for correction</label>
                        </span>
                    </div>
                    <div class="col-md-6">
                        <input class="form-control"
                               placeholder="Comment: What is wrong?"
                               type="text"
                               :name="'comments['+qid+']'"
                               :id="'comment_'+qid"
                               style="margin-top: -10px; display:none;">
                    </div>
                </div>
            </div>

            <!-- Question Properties -->
            <div class="col-md-4 quiz-left-column question-row">
                <b>{{level === 1 ? 'Easy' : level === 2 ? 'Medium' : 'Hard'}}</b>
                <br/>
                <b>{{camelCaseToWords(type)}}</b>
                <br/><br/>
                <div align="center" style="margin-bottom: 10px;" v-if="pictureUrl !== ''">
                    <a :href="pictureUrl" target="_blank" tabindex="-1">
                        <img :src="pictureUrl" style="max-height: 50px; max-width: 50px;"/>
                    </a>
                </div>
            </div>

            <!-- Question Text -->
            <div class="col-md-4 quiz-text-column question-row">
                <h4>_Master / {{originLanguage}}</h4>
                <p dir="auto" class="katexRenderText">{{originText}}</p>
            </div>
            <div class="col-md-4 quiz-text-column question-row">
                <h4>{{country}} / {{language}}</h4>
                <p dir="auto" class="katexRenderText">{{translation}}</p>
            </div>
        </div>


        <!-- Options -->

        <div class="row" style="margin-top: 3px;" v-for="option in options">
            <!-- Option Properties -->
            <div class="col-md-4 quiz-left-column option-row"
                 v-bind:class="{'text-success': option.isCorrect, 'text-danger': !option.isCorrect}">
                <i class="fa" v-bind:class="{'fa-check': option.isCorrect, 'fa-times': !option.isCorrect}"></i>
                <b>{{option.isCorrect ? 'Correct' : 'Incorrect'}}</b><br/>
                <span style="color: #444" v-if="option.oid === suggestedAnswerOid"><b>Suggested Answer</b></span>
            </div>

            <!-- Option Text -->
            <div class="col-md-4 quiz-text-column option-row">
                <p dir="auto" class="katexRenderText">{{option.text[originLocale]}}</p>
            </div>
            <div class="col-md-4 quiz-text-column option-row">
                <p dir="auto" class="katexRenderText">{{option.text[destLocale]}}</p>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            idx: Number,
            qid: String,
            type: String,
            level: Number,
            originText: String,
            translation: String,
            options: Array,
            pictureUrl: String,
            destLocale: String,
            language: String,
            country: String,
            originLocale: String,
            originLanguage: String,
            suggestedAnswerOid: String,
        },

        methods: {
            camelCaseToWords: (camelCased) => {
                return camelCased.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + camelCased.replace(/([A-Z])/g, ' $1').slice(1);
            },
            handleChange: (event) => {
                const checkbox = event.target;
                const label = checkbox.parentNode.lastChild;
                const input = checkbox.parentNode.parentNode.nextSibling.firstChild;

                label.style.backgroundColor = checkbox.checked ? 'LightSalmon' : 'white';
                input.style.display = checkbox.checked ? '' : 'none';
            },
        },
    };
</script>
